export default "__VITE_ASSET__a5ce1c04__"